import * as React from "react";
import { cn } from "@/lib/utils";
import "./toggle-pills.css";

function TogglePillGroup({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="toggle-pill-group"
      className={cn("toggle-pill-group", className)}
      role="group"
      {...props}
    />
  );
}

function TogglePill({
  active = false,
  className,
  ...props
}: React.ComponentProps<"button"> & {
  active?: boolean;
}) {
  return (
    <button
      data-slot="toggle-pill"
      type="button"
      data-active={active}
      aria-pressed={active}
      className={cn("toggle-pill", className)}
      {...props}
    />
  );
}

export { TogglePillGroup, TogglePill };
